import React, { useEffect, useState } from "react";
import classNames from "classnames";

import EngineLoader from "$components/loaders/engine-loader";
import RecommendationPanel from "$components/recommendation-panel";

import { ClientDetailsStore } from "$stores/client-details";
import { calculateScoreMark, getHealthColorClassByRange } from "$utils/health-helper";
import { getTerm } from "$stores/dictionary";
import { ScoreCardStore } from "$stores/scorecard";
import { useDocumentTitle } from "$utils/document-title";
import { setHelpContent } from "$stores/help";
import { HELP_CLIENT_RECOMMENDATIONS } from "../help/lib/help-contents";

const ClientRecommendations = () => {
    useDocumentTitle(`${getTerm("parentClient")} Recommendations`);
    const healthScore = ClientDetailsStore.useState((s) => s.clientDetails?.healthScore);
    const recommendationData = ScoreCardStore.useState((s) => s.recommendations);

    const [scoreInfo, setScoreInfo] = useState({
        healthRange: "",
        healthClass: "",
        tooltip: "",
    });

    useEffect(() => {
        setHelpContent(HELP_CLIENT_RECOMMENDATIONS);
    }, []);

    useEffect(() => {
        if (healthScore) {
            const scoreMark = calculateScoreMark(healthScore);
            setScoreInfo({
                healthRange: scoreMark.label,
                healthClass: getHealthColorClassByRange(scoreMark.label),
                tooltip: scoreMark.tooltip,
            });
        }
    }, [healthScore]);

    const recommendations = recommendationData ? (
        recommendationData.map((d, i) => {
            return <RecommendationPanel key={`recommendation_${i}`} index={i + 1} data={d} />;
        })
    ) : (
        <EngineLoader />
    );

    return (
        <div id="recommendations">
            <h2>
                <span data-tooltip={getTerm("tooltipRecommendations")}>
                    <em>Orgaimi</em> Recommendations
                </span>
            </h2>
            <p>
                Your {getTerm("parentClient").toLowerCase()} is in the{" "}
                <span className={classNames("txt -uppercase -bold", scoreInfo.healthClass)} data-tooltip={scoreInfo.tooltip}>
                    {scoreInfo.healthRange}
                </span>{" "}
                range of health scores. To improve your health score, consider the following trends:
            </p>
            {recommendations}
            {recommendationData && recommendations.length === 0 && (
                <>
                    <br />
                    <br />
                    <h4 className="txt -center">No Recommendations Available</h4>
                </>
            )}
        </div>
    );
};

export default ClientRecommendations;
